"use client";

import * as RadixHoverCard from "@radix-ui/react-hover-card";
import type { ReactNode } from "react";

interface HoverCardProps {
	trigger: ReactNode;
	children: ReactNode;
	className?: string;
	alignOffset?: number;
	sideOffset?: number;
	side?: "left" | "right" | "bottom" | "top";
	align?: "start" | "center" | "end";
	sticky?: "partial" | "always";
	hideWhenDetached?: boolean;
}

export function HoverCard({
	trigger,
	children,
	...props
}: HoverCardProps): React.ReactElement {
	return (
		<RadixHoverCard.Root>
			<RadixHoverCard.Trigger>{trigger}</RadixHoverCard.Trigger>
			<RadixHoverCard.Portal>
				<RadixHoverCard.Content {...props}>{children}</RadixHoverCard.Content>
			</RadixHoverCard.Portal>
		</RadixHoverCard.Root>
	);
}
